import React from "react";
import { classNames } from "../../../common";

type props = {
    classes?: Array<string>
}

const Spinner = ({ classes }: props) => {
    const styles = `loader ease-linear rounded-full border-4 border-t-8 border-gray-200 h-36 w-36 mb-4 animate-spin ${classes && classNames(classes)} `;

    return (
        <div className={styles}></div>
    );
}

export default Spinner;
